import { z } from "zod";

export const videoReportParticipantSchema = z.object({
	user_id: z.uuid(),
	first_name: z.string(),
	last_name: z.string(),
	photo_url: z.string().nullable(),
	joined_at: z.iso.datetime(),
	left_at: z.iso.datetime().nullable(),
	duration_seconds: z.number().nullable(),
});

export const videoReportResponseSchema = z.object({
	session: z.object({
		started_at: z.iso.datetime().nullable(),
		ended_at: z.iso.datetime().nullable(),
		duration_seconds: z.number().nullable(),
		recording_url: z.string().nullable(),
	}),
	participants: z.array(videoReportParticipantSchema),
});

export type VideoReportParticipant = z.infer<typeof videoReportParticipantSchema>;
export type VideoReportResponse = z.infer<typeof videoReportResponseSchema>;
